<template>
  <div class="fixed-bar">
    <div class="container">
      <slot />
    </div>
    <cst-menu></cst-menu>
  </div>
</template>

<script>
import CstMenu from '@/components/generic/presentational/molecules/cstMenu/CstMenu.vue'
export default {
  components: {
    CstMenu,
  },
}
</script>

<style lang="scss" scoped>
.fixed-bar {
  position: sticky;
  width: 100%;
  z-index: z-index(fixed-bar);
  background-color: $white;
  top: 0;

  @include breakpoint-max(1540px) {
    padding: 0 3.5rem;
  }

  .container {
    @include center;
  }

  :deep(.fixed-bar--bar) {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
</style>
